import MDBox from "components/MDBox";
import React, { useState, useEffect } from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Accordion, AccordionSummary, AccordionDetails, Icon } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import ItemsTable from "../Items";
import Autocomplete from '@mui/material/Autocomplete';


export default function Attachments(props) {


    return (
        <MDBox pt={1} pb={2} px={2}>
            <MDBox component="ul" display="flex" flexDirection="column" p={0} m={0}>
                {props.files.map((item, ind) => (
                    <MDBox
                        component="li"
                        display="flex"
                        justifyContent="space-between"
                        alignItems="flex-start"
                        bgColor={"grey-100"}
                        borderRadius="lg"
                        p={2}
                        // mb={1}
                        mt={2}
                    >
                        <MDBox width="100%" display="flex" flexDirection="column">
                            <MDBox
                                display="flex"
                                justifyContent="space-between"
                                alignItems={{ xs: "flex-start", sm: "center" }}
                                flexDirection={{ xs: "column", sm: "row" }}
                            >
                                <MDTypography variant="button" fontWeight="medium" textTransform="capitalize">
                                    {item.name}
                                </MDTypography>

                                <MDBox display="flex" alignItems="center" mt={{ xs: 2, sm: 0 }} ml={{ xs: -1.5, sm: 0 }}>
                                    <MDBox mr={1}>
                                        <MDButton variant="text" color="success" onClick={() => {
                                            props.viewAttachment(ind);
                                        }}>
                                            <Icon>visibility</Icon>&nbsp;view
                                        </MDButton>
                                        <MDButton variant="text" color="error" onClick={() => {
                                            props.removeAttachment(ind);
                                        }}>
                                            <Icon>delete</Icon>&nbsp;delete
                                        </MDButton>
                                    </MDBox>
                                </MDBox>
                            </MDBox>
                        </MDBox>
                    </MDBox>
                ))}

            </MDBox>
        </MDBox>
    );
}